export const DEFAULT_FILTER = ':/'
